export default {
    serverURL:'https://wxwork.leica-camera.cn/',
    nameTitle:"徕卡企业号",
    wxauth : true, //启用企业号页面授权验证
    //https://wechatworkleica-camera.cn/h5/task/guideTask_cebianlan.html?userld=&externalUserld=
    taskBaseUrl:'https://batools.leica-camera.cn/h5/task/guideTask_cebianlan.html'
}



// WEBPACK FOOTER //
// ./src/config/config.js